import Mutations from '../../odata/mutations';

export default { ...new Mutations('contact'), ...new Mutations('contacts') };
